import { CheckmarkIc } from '@dsch/dd-icons';
import styled from 'styled-components';

import { DetailList } from '../../../../components/Toolkit/DetailList/DetailList';
import { media } from '../../../../helpers/breakpoints';
import { PAGE } from '../../../../helpers/pages';

export interface IInfoPanelList {
  listItems: string[];
  pageName: string;
}

const AssumptionList = styled.div<{ pageName: string }>`
  background: ${({ theme }) => theme.colors.WHITE};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  padding: ${({ theme }) => `${theme.spacing.M24} ${theme.spacing.M16}`};
  margin-bottom: ${({ theme, pageName }) =>
    pageName === PAGE.INSTANT_OFFER_VALUATION ? theme.spacing.L40 : 0};
  width: 100%;
  ${media.large} {
    padding: ${({ theme }) => theme.spacing.M24};
    max-width: 760px;
  }
`;

export const Title = styled.div`
  ${({ theme }) => theme.fontSize.M16}
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  text-align: left;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const SDetailList = styled(DetailList)`
  row-gap: ${({ theme }) => theme.spacing.M16};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const Legal = styled.p`
  ${({ theme }) => theme.fontSize.B14}
`;

export const SIoCheckmark = styled(CheckmarkIc)`
  color: ${({ theme }) => theme.colors.GREEN};
`;

function InfoPanelList({ listItems, pageName }: IInfoPanelList) {
  const privateValuationAssumptionLegalText =
    ' *Valuations are valid for 14 days. For Instant Offer, valuations given and offers made are subject to vehicle inpection by one of our partners and may change if the vehicle, it’s condition and/or history is not as described.';

  const instantOfferAssumptionLegalText =
    '*Your estimate is valid for 14 days. All offers made by our trusted dealers are subject to a vehicle inspection and may change if the vehicle, its condition and/or history is not as described. If any of the above listed assumptions are not reflective of your circumstance, please inform the dealer once contact has been made so they may adjust your offer accordingly.';

  return (
    <AssumptionList pageName={pageName}>
      <Title>*Assumptions we’ve made:</Title>
      <SDetailList
        singleColumnOnDesktop={true}
        list={listItems?.map((item) => ({
          title: item,
          icon: <SIoCheckmark width="16" height="16" />,
        }))}
      />
      <Legal>
        {pageName === PAGE.INSTANT_OFFER_VALUATION
          ? instantOfferAssumptionLegalText
          : privateValuationAssumptionLegalText}
      </Legal>
    </AssumptionList>
  );
}

export { InfoPanelList };
